import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

const tagClasses = {
  personal: "note-personal",
  work: "note-work",
  social: "note-social",
  important: "note-important",
  "": "note-default"
};

const NoteCard = ({ note, onDelete, onToggleFav, onTagChange, setLoading }) => {

  const VITE_BASE_URL = process.env.REACT_APP_API_URL;
  const [tag, setTag] = useState(note.tag || "");
  const [isFav, setIsFav] = useState(Boolean(note.isFav));

  useEffect(() => {
    setIsFav(Boolean(note.isFav));
  }, [note.isFav]);

  const handleTagChange = async (newTag) => {
    setLoading?.(true);
    try {
      const res = await fetch(`${VITE_BASE_URL}/api/notes/tag/${note._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ tag: newTag }),
      });

      const result = await res.json();
      if (res.ok) {
        setTag(newTag);
        if (onTagChange) {
          onTagChange(note._id, newTag);  // Call parent to update main list
        }
      } else {
        toast.error(result.message || 'Tag update failed');
      }
    } catch (err) {
      console.error('Error updating tag:', err);
      toast.error('Server error during tag update');
    }
    finally {
      setLoading?.(false);
    }
  };


  const handleFavToggle = async () => {
    setLoading?.(true);
    try {
      const res = await fetch(`${VITE_BASE_URL}/api/notes/fav/${note._id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ isFav: !isFav }),
      });
      const result = await res.json();
      if (result.success) {
        setIsFav(!isFav);
        onToggleFav?.(note._id, !isFav);
      }
    } catch (err) {
      console.error("Error updating favourite status:", err);
    } finally {
      setLoading?.(false);
    }
  };

  const handleDelete = async () => {
    setLoading?.(true);
    try {
      const res = await fetch(`${VITE_BASE_URL}/api/notes/${note._id}`, {
        method: 'DELETE'
      });
      const result = await res.json();
      if (result.success) {
        onDelete && onDelete(note._id); // Inform parent to remove it from list
      }
    } catch (err) {
      console.error("Error deleting note:", err);
    }
    finally {
      setLoading?.(false);
    }
  };

  const formattedDate = new Date(note.crtdOn).toLocaleDateString();

  return (
    <div className={`note-item all-notes ${tagClasses[tag] || 'note-default'}`}>
      <div className="note-inner-content">
        <div className="note-content">
          <p className="note-title" data-notetitle={note.title}>{note.title}</p>
          <p className="meta-time">{formattedDate}</p>
          <div className="note-description-content">
            <p className="note-description" data-notedescription={note.desc}>{note.desc}</p>
          </div>
        </div>
        <div className="note-action">
          {/* Favourite Star */}
          <svg
            onClick={handleFavToggle}
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill={isFav ? "gold" : "none"}
            stroke={isFav ? "gold" : "currentColor"}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-star fav-note"
            style={{ cursor: 'pointer' }}
          >
            <polygon
              points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 
              12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
              fill={isFav ? "gold" : "none"} // Fully filled star
            />
          </svg>

          {/* Delete Icon */}
          <svg
            onClick={handleDelete}
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-trash-2 delete-note"
            style={{ cursor: 'pointer' }}
          >
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
            <line x1={10} y1={11} x2={10} y2={17} />
            <line x1={14} y1={11} x2={14} y2={17} />
          </svg>
        </div>

        <div className="note-footer">
          <div className="tags-selector btn-group">
            <a className="nav-link dropdown-toggle d-icon label-group" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="true">
              <div className="tags">
                <div className="g-dot-personal" />
                <div className="g-dot-work" />
                <div className="g-dot-social" />
                <div className="g-dot-important" />
                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24}
                  viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
                  className="feather feather-more-vertical">
                  <circle cx={12} cy={12} r={1} />
                  <circle cx={12} cy={5} r={1} />
                  <circle cx={12} cy={19} r={1} />
                </svg>
              </div>
            </a>
            <div className="dropdown-menu dropdown-menu-right d-icon-menu">
              {["personal", "work", "social", "important"].map((t) => (
                <a
                  key={t}
                  onClick={() => handleTagChange(t)}
                  className={`dropdown-item position-relative g-dot-${t} note-${t} label-group-item label-${t}`}
                  href="#"
                >
                  {t.charAt(0).toUpperCase() + t.slice(1)}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoteCard;
